export default "__VITE_ASSET__CV7Uwr96__"